import { MethodsEnum } from './../../constants/enums'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { LogoutResponse, UserResponse } from '../../constants/types'
import { LOGOUT_URL, USER_URL } from '../../constants/urls'

export const usersApi = createApi({
  reducerPath: 'users/api',
  baseQuery: fetchBaseQuery(),
  endpoints: (build) => ({
    getUser: build.query<UserResponse, void>({
      query: () => ({
        url: USER_URL,
        credentials: 'include',
      }),
    }),
    logout: build.mutation<LogoutResponse, void>({
      query: () => ({
        url: LOGOUT_URL,
        credentials: 'include',
        method: MethodsEnum.POST,
      }),
    }),
  }),
})
